// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsTotalEc2InstancesIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-total-ec2-instances_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M26.05 27 26 13.95 13 14v13.05zM27 14h2v1h-2v2h2v1h-2v2h2v1h-2v2h2v1h-2v2h2v1h-2v.05c0 .52-.43.95-.95.95H26v2h-1v-2h-2v2h-1v-2h-2v2h-1v-2h-2v2h-1v-2h-2v2h-1v-2h-.05a.95.95 0 0 1-.95-.95V27h-2v-1h2v-2h-2v-1h2v-2h-2v-1h2v-2h-2v-1h2v-2h-2v-1h2v-.05c0-.52.43-.95.95-.95H13v-2h1v2h2v-2h1v2h2v-2h1v2h2v-2h1v2h2v-2h1v2h.05c.52 0 .95.43.95.95zm-6 19H7V19h2v-1H7.06C6.48 18 6 18.48 6 19.06v13.88c0 .58.48 1.06 1.06 1.06h13.88c.58 0 1.06-.48 1.06-1.06V31h-1zM34 7.06v13.88c0 .58-.48 1.06-1.06 1.06H30v-1h3V7H19v3h-1V7.06c0-.58.48-1.06 1.06-1.06h13.88c.58 0 1.06.48 1.06 1.06"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-total-ec2-instances_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsTotalEc2Instances",
);
export default AwsTotalEc2InstancesIcon;
